<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { totalItems } = defineProps<{ totalItems: number }>();
</script>

<template>
  <div class="order-card-item-list-title">
    <Text font="body-medium-18">{{ $t("Товары") }}</Text>
    <Text font="body-regular-14" color="secondary">{{ `${totalItems} ${$t("шт")}.` }}</Text>
  </div>
</template>

<style scoped>
  .order-card-item-list-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
</style>
